/*
 * @Description: logger
 * @Date: 2022-04-11 19:39:55
 * @LastEditTime: 2022-04-12 11:37:24
 */
import { LogLevelType, LogContext, getLogPrefix } from './logger-utils';
export * from './logger-utils';

const isDebugEnabled = process.env.NODE_ENV === 'development';

let currentLogLevel = isDebugEnabled
  ? LogLevelType.LOG_LEVEL_DEBUG
  : LogLevelType.LOG_LEVEL_NON_LOGGING;

export const logger = {
  /** Print debug logs when current level allows debug output. */
  debug(...args: any[]) {
    if (currentLogLevel <= LogLevelType.LOG_LEVEL_DEBUG) {
      console.debug(`${getLogPrefix(LogContext.RENDER)}`, ...args);
    }
  },
  /** Print standard logs when current level allows log output. */
  log(...args: any[]) {
    if (currentLogLevel <= LogLevelType.LOG_LEVEL_LOG) {
      console.log(`${getLogPrefix(LogContext.RENDER)}`, ...args);
    }
  },
  /** Print info logs when current level allows info output. */
  info(...args: any[]) {
    if (currentLogLevel <= LogLevelType.LOG_LEVEL_INFO) {
      console.info(`${getLogPrefix(LogContext.RENDER)}`, ...args);
    }
  },
  /** Print warning logs when current level allows warn output. */
  warn(...args: any[]) {
    if (currentLogLevel <= LogLevelType.LOG_LEVEL_WARN) {
      console.warn(`${getLogPrefix(LogContext.RENDER)}`, ...args);
    }
  },
  /** Print error logs when current level allows error output. */
  error(...args: any[]) {
    if (currentLogLevel <= LogLevelType.LOG_LEVEL_ERROR) {
      console.error(`${getLogPrefix(LogContext.RENDER)}`, ...args);
    }
  },
  /** Update current log level at runtime. */
  setLevel(newLevel: number) {
    if (
      newLevel >= LogLevelType.LOG_LEVEL_DEBUG &&
      newLevel <= LogLevelType.LOG_LEVEL_NON_LOGGING
    ) {
      console.log(
        `${getLogPrefix(
          LogContext.RENDER
        )} set log level from ${currentLogLevel} to ${newLevel}`
      );
      currentLogLevel = newLevel;
    } else {
      console.error(
        `${getLogPrefix(
          LogContext.RENDER
        )} logger.setLevel() invalid params:${newLevel}`
      );
    }
  },
  /** Get current active log level. */
  getLevel() {
    return currentLogLevel;
  },
};
